import { render } from "./SpecialitySelector.vue?vue&type=template&id=45f6f93b&scoped=true"
import script from "./SpecialitySelector.vue?vue&type=script&lang=js"
export * from "./SpecialitySelector.vue?vue&type=script&lang=js"

import "./SpecialitySelector.vue?vue&type=style&index=0&id=45f6f93b&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45f6f93b"]])

export default __exports__